/**
 * Collection of design tokens for typography, specifying font families for different typographic
 * scenarios.
 */ const fontFamilies = {
    regular: `'InterVariable', 'Inter', 'sans-serif'`,
    mono: `'Roboto Mono', 'monospace'`
};

export { fontFamilies };
//# sourceMappingURL=font-families.js.map
